import React, { useMemo } from "react";
import InitialDataListPage from "../components/InitialDataListPage";

const MOMENT_LABELS = {
  days: "วัน",
  weeks: "สัปดาห์",
  months: "เดือน",
  years: "ปี",
};

const TYPE_LABELS = {
  CONTRACT: "ระยะสัญญา",
  SERVICE: "จำนวนบริการตรวจเช็ค",
};

const TimeUnitMain = ({ masterList = [], name, onPageInsert, onRowSelected }) => {
  const columns = useMemo(
    () => [
      {
        key: "index",
        header: "#",
        width: "6%",
        align: "center",
        render: (_item, _index, { startIndex, itemIndex }) =>
          startIndex + itemIndex + 1,
      },
      {
        key: "TimeUnit_Code",
        header: "รหัส",
        width: "10%",
        align: "center",
        render: (item) => item.TimeUnit_Code ?? "-",
      },
      {
        key: "TimeUnit_Name",
        header: "ชื่อหน่วย",
        width: "28%",
        align: "start",
        render: (item) => item.TimeUnit_Name || "-",
      },
      {
        key: "TimeUnit_Type",
        header: "ประเภท",
        width: "22%",
        align: "center",
        render: (item) => TYPE_LABELS[item.TimeUnit_Type] || item.TimeUnit_Type || "-",
      },
      {
        key: "TimeUnit_Moment",
        header: "ใช้คำนวณ",
        width: "18%",
        align: "center",
        render: (item) =>
          MOMENT_LABELS[item.TimeUnit_Moment] || item.TimeUnit_Moment || "-",
      },
      {
        key: "TimeUnit_Status",
        header: "สถานะ",
        width: "8%",
        align: "center",
        render: (item) => (item.TimeUnit_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน"),
      },
      {
        key: "actions",
        header: "แก้ไข",
        width: "8%",
        align: "center",
        isAction: true,
        render: (item, _index, { triggerRowSelected }) => (
          <button
            onClick={(event) => {
              event.stopPropagation();
              triggerRowSelected(item);
            }}
            className="btn btn-sm"
            title="แก้ไข"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#fff3e0",
              color: "#EF6C00",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(event) => {
              event.currentTarget.style.backgroundColor = "#EF6C00";
              event.currentTarget.style.color = "#fff";
            }}
            onMouseOut={(event) => {
              event.currentTarget.style.backgroundColor = "#fff3e0";
              event.currentTarget.style.color = "#EF6C00";
            }}
            type="button"
          >
            <i className="fas fa-edit" />
          </button>
        ),
      },
    ],
    []
  );

  const getSearchValues = useMemo(
    () => (item) => [
      item?.TimeUnit_Code,
      item?.TimeUnit_Name,
      TYPE_LABELS[item?.TimeUnit_Type] || item?.TimeUnit_Type,
      MOMENT_LABELS[item?.TimeUnit_Moment] || item?.TimeUnit_Moment,
      item?.TimeUnit_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
    ],
    []
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/timeunit"
      data={masterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      searchPlaceholder={`ค้นหา${name || "หน่วยเวลา"}...`}
      fieldMappings={{ no: "TimeUnit_Id" }}
      getRowId={(item) => item?.TimeUnit_Id}
    />
  );
};

export default TimeUnitMain;
